<template>
  <v-container class="pt-6">
    <v-row justify="center">
      <v-col cols="12" v-if="grupos.length">
        <v-card class="mx-auto transparent elevation-0">
          <v-card-text>
            <div class="mb-0 font-weight-bold text-h5 textPrimary--text text-center">
              Mis grupos
            </div>
          </v-card-text>
        </v-card>
      </v-col>

      <!-- Alerta de que no tienes grupos asignados -->
      <!-- Avisos -->
      <SinGrupos   v-if="!grupos.length"               />

      <!-- Grupos asignados -->
      <GruposTeacherList v-else :grupos="grupos"/>



      <!-- Subir Video de 14vo nivel -->
      <v-col cols="12" sm="6" md="6" lg="4" v-if="subirVideo.visible">
        <CargarVideoTeacher v-if="subirVideo.visible" :subirVideo="subirVideo"/>
      </v-col>
    </v-row>
    
    <v-speed-dial
      bottom
      right
      fixed
      class="mb-12"
    >
      <template v-slot:activator>
        <v-btn
          color="blue darken-2"
          dark
          fab
          @click="actualizarGrupos(), getSubirVideo()"
        >
          <v-icon>
            mdi-refresh
          </v-icon>
        </v-btn>
      </template>
    </v-speed-dial>

    <!-- Alertas -->
    <Alerta      v-if="respuestaAlerta" :parametros="parametros"/>
    <Loader      v-if="cargar"          :loader="loader"/>

  </v-container>
</template>
<script>
  // Importar lebrerías
  import { mapGetters, mapActions } from 'vuex'
  const  base64 = require('base-64');

  // Componentes
  import Alerta     from '@/components/alertas/Alerta.vue'
  import Loader     from '@/components/alertas/Loader.vue'

  import SinGrupos           from '@/components/grupos/SinGrupos.vue'
  import GruposTeacherList   from '@/components/grupos/GruposTeacherList.vue'
  import CargarVideoTeacher  from '@/components/avisos/CargarVideoTeacher.vue'

  export default {
    components:{
      Alerta,
      Loader,
      SinGrupos,
      GruposTeacherList,
      CargarVideoTeacher
    },

    data () {
      return {
        respuestaAlerta:false,
        parametros:{
          dialogError: false,
          mensaje: '',
          color: ''
        },
        loader: true,
        cargar: false,

        grupos: [],
        subirVideo:{
          visible: false,
          id_grupo: 0,
        },
      }
    },

    computed:{
      ...mapGetters( 'login', [ 'getGrupo', 'getUsuarioLMS', 'getRecursosGrupoUsuario', 'getEscuela' ]),
    },

    async created ( ){

      console.log( this.getUsuarioLMS )
      await this.getGrupos( )
      await this.getSubirVideo()

    },

    methods:{
      ...mapActions( 'login', [ 'abrirGrupo', 'grabarGruposUsuario', 'salirLogin' ]),

      getGrupos ( ){
        this.cargar = true
        // Preparamos el id del teacher
        const id_teacher = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la consulta
        this.$http.get('grupos.teachers/' + id_teacher ).then( response=> {
          this.grupos = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      getSubirVideo( ){
        const id_usuario = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la petición
        this.$http.get('grabar.video.teachers/' + id_usuario).then( response => {
          this.subirVideo.visible = true
          this.subirVideo.id_grupo = response.body.id_grupo
        }).catch( error =>{
          this.cargar = false
        }).finally(()=>{ this.cargar = false })
      },

      actualizarGrupos ( ) {
        this.cargar = true
        // Preparamos el id del teacher
        const id_teacher = base64.encode( this.getUsuarioLMS.id )
        // Hacemos la consulta
        this.$http.get('grupos.teachers/' + id_teacher ).then( response=> {
          this.grupos = response.body
        }).catch( error =>{
          this.validarError( error )
        }).finally( () => { this.cargar = false })
      },

      validarError ( value ) {
        this.cargar = false 
        if( value.status == 400 || value.status == 500){
          this.parametros.mensaje      = value.body.message
          this.parametros.dialogError  = true 
          this.parametros.color        = '#FF2C2C'
          this.respuestaAlerta = true 
        }
      },

    }
  }
</script>

<style scoped>

</style>